import { render, staticRenderFns } from "./SummaryCategory.vue?vue&type=template&id=38145324"
import script from "./SummaryCategory.vue?vue&type=script&lang=js"
export * from "./SummaryCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports